import React, { useContext, useEffect, useRef } from "react";
import WindowIcon from "../WindowIcon/WindowIcon";
import Code from "../Code/Code";
import interact from "interactjs";
import { getValue, handleChange } from "../../utils/update.utils";
import { Context } from "../../context/Context";
import { closeMenu } from "../../helper/menu";
export default function Main() {
  const {
    state,
    setState,
    codeRef,
    resizeX,
    resizeY,
    menus,
    setMenus,
    setIsOpen,
  } = useContext(Context);

  const cardWidth = useRef(null);
  const cardHeight = useRef(null);
  const xMeas = useRef(null);
  const yMeas = useRef(null);
  useEffect(() => {
    interact(".resizable").resizable({
      edges: {
        left: false,
        right: ".resize-r",
        bottom: ".resize-b",
        top: false,
      },

      listeners: {
        move: (event) => {
          if (getValue(menus, null, true)?.txt === "Export") {
            closeMenu(menus, setMenus, setIsOpen);
          } else {
            xMeas.current.classList.remove("opacity-0");
            yMeas.current.classList.remove("opacity-0");
            var target = event.target;
            var x = parseFloat(target.getAttribute("data-x")) || 0;
            var y = parseFloat(target.getAttribute("data-y")) || 0;

            // update the element's style
            target.style.width = event.rect.width + "px";
            target.style.minHeight = event.rect.height + "px";

            // translate when resizing from top or left edges
            x += event.deltaRect.left;
            y += event.deltaRect.top;

            target.style.transform = "translate(" + x + "px," + y + "px)";

            target.setAttribute("data-x", x);
            target.setAttribute("data-y", y);
            // target.textContent = Math.round(event.rect.width) + '\u00D7' + Math.round(event.rect.height)
            cardWidth.current.textContent = `${Math.round(event.rect.width)}px`;
            cardHeight.current.textContent = `${Math.round(
              event.target.offsetHeight
            )}px`;
            setTimeout(() => {
              xMeas.current.classList.add("opacity-0");
              yMeas.current.classList.add("opacity-0");
            }, 3000);
          }
        },
      },
      modifiers: [
        // keep the edges inside the parent
        interact.modifiers.restrictEdges({
          outer: "parent",
        }),

        // minimum size
        interact.modifiers.restrictSize({
          min: { width: 400, height: 300 },
          max: { width: 768, height: 100000000000000 },
        }),
      ],

      inertia: true,
    });
  }, []);
  return (
    <div
      ref={codeRef}
      className={`bg-gradient-to-br  resizable transition-all duration-200 transform-gpu ease-linear md:px-12 md:py-20 px-7 py-12 flex items-center justify-center mx-auto w-full relative max-w-screen-md rounded-md my-28 lgx:my-52   
      ${
        state.theme.backgroundNoFill
          ? "bg-none"
          : getValue(state, ["theme", "background"]).custom
          ? ""
          : getValue(state, ["theme", "background"]).value
      }`}
      style={
        getValue(state, ["theme", "background"])?.custom
          ? { background: getValue(state, ["theme", "background"]).value }
          : getValue(state, ["theme", "background"])?.image
          ? {
              background: `url(${
                getValue(state, ["theme", "background"]).value
              })`,
              backgroundSize: "cover",
              backgroundRepeat: "no-repeat",
            }
          : null
      }
    >
      <div
        className={`code transition-all duration-200 transform-gpu ease-linear        ${
          getValue(state, ["window", "controls"]).rounded && "rounded-md"
        }
        p-4 w-full ${
          getValue(state, ["theme", "codeTheme"]).theme === "dark"
            ? "bg-cool-gray-800"
            : "bg-white"
        }
        shadow-${getValue(state, ["window", "shadow"]).value}
        `}
      >

        <div className="flex items-center justify-center pt-2 pb-2 relative">
          {getValue(state, ["window", "controls"]).controls && <WindowIcon />}

          <input
            onChange={(e) =>
              setState(handleChange(e.target.value, state, "fileName"))
            }
            className={`w-28 h-6 appearance-none bg-transparent focus:border-transparent border-transparent focus:outline-none border-none ${
              getValue(state, ["theme", "codeTheme"]).theme === "dark"
                ? "text-gray-400"
                : "text-gray-500"
            } text-sm text-center z-40 box-border`}
            value={state.fileName}
          />
          <span></span>
        </div>
        <div className="">
          <Code codeRef={codeRef} />
        </div>
      </div>
      {/* X measurement */}
      <div
        ref={xMeas}
        className="border-l border-r h-2 lgx:h-4  border-gray-900 border-opacity-20 w-full absolute lgx:-bottom-8 -bottom-4 flex items-center justify-between opacity-0 transition-opacity duration-200 ease-in-out"
      >
        <div className="border-b border-gray-900 border-opacity-20 w-1/2"></div>
        <span className="text-gray-500 bg-white z-10 px-5" ref={cardWidth}>
          1000px
        </span>
        <div className="border-b border-gray-900 border-opacity-20 w-1/2"></div>
      </div>
      {/* Y measurement */}
      <div
        ref={yMeas}
        className="border-t border-b w-2 lgx:w-4  border-gray-900 border-opacity-20 h-full absolute lgx:-right-8 -right-4 flex opacity-0 transition-opacity duration-200 ease-in-out"
      >
        <div className="h-full w-full relative flex flex-col items-center justify-center">
          <div className="border-l border-gray-900 border-opacity-20 h-1/2 absolute top-0"></div>
          <span
            className="text-gray-500 transform rotate-90 bg-white z-10 px-5"
            ref={cardHeight}
          >
            1000px
          </span>
          <div className="border-l border-gray-900 border-opacity-20 h-1/2 absolute bottom-0"></div>
        </div>
      </div>

      {/* Resize Buttons */}
      <div
        ref={resizeX}
        className="absolute hidden md:block -right-1 resize-r border border-gray-300 shadow-lg top-50% lgx:w-3 w-2  lgx:h-3 h-2  bg-white rounded-full transition duration-300 ease-in-out transform hover:scale-125"
      ></div>
      <div
        ref={resizeY}
        className="absolute md:block -bottom-1 resize-b border border-gray-300 shadow-lg top-50% lgx:w-3 w-2  lgx:h-3 h-2  bg-white rounded-full transition duration-300 ease-in-out transform hover:scale-125"
      ></div>
    </div>
  );
}
